<template>
    <table>
        <thead>
            <tr>
            <th>Cancer Subtype</th>
            <th colspan="2" style="text-align: center;">TNBC</th>
            <th colspan="2" style="text-align: center;">Non-TNBC</th>
            <th colspan="2" style="text-align: center;border-bottom: 0px;">Recommended</th>
            </tr>
            <tr>
            <th>Group</th>
            <th class="flexible-width" style="text-align: center;">CAP treatment</th>
            <th class="flexible-width" style="text-align: center;">Control</th>
            <th class="flexible-width" style="text-align: center;">CAP treatment</th>
            <th class="flexible-width" style="text-align: center;">Control</th>
            <th colspan="2" style="text-align: center;border-top: 0px;">Analysis Approach</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="item in data" :key="item.key" :class="{highlight: selectedRowKey.includes(item.key)}">
            <td :class="getLeftClass(item.key)">{{ item.group }}</td>
            <td :class="['flexible-width', getClass(item['TNBC-CAP treatment'], item.key)]">{{ item['TNBC-CAP treatment'] }}</td>
            <td :class="['flexible-width', getClass(item['TNBC-Control'], item.key)]">{{ item['TNBC-Control'] }}</td>
            <td :class="['flexible-width', getClass(item['Non-TNBC-CAP treatment'], item.key)]">{{ item['Non-TNBC-CAP treatment'] }}</td>
            <td :class="['flexible-width', getClass(item['Non-TNBC-Control'], item.key)]">{{ item['Non-TNBC-Control'] }}</td>
            <td v-if="item.key % 2 === 1" :rowspan="2">{{ item.recommendedAnalysis }}</td>
            </tr>
        </tbody>
    </table>
  </template>
  
  <script>
  export default {
    data() {
      return {
        selectedRowKey: [],
        data: [
          {
            key: '1',
            group: 'Whole transcriptome, CAP 1h',
            'TNBC-CAP treatment': 'Available',
            'TNBC-Control': 'Available',
            'Non-TNBC-CAP treatment': 'Available',
            'Non-TNBC-Control': 'Available',
            recommendedAnalysis: 'Dynamics Response'
          },
          {
            key: '2',
            group: 'Whole transcriptome, CAP 8h',
            'TNBC-CAP treatment': 'Available',
            'TNBC-Control': 'Available',
            'Non-TNBC-CAP treatment': 'Available',
            'Non-TNBC-Control': 'Available',
            recommendedAnalysis: ''
          },
          {
            key: '3',
            group: 'Acetylation',
            'TNBC-CAP treatment': 'Available',
            'TNBC-Control': 'Available',
            'Non-TNBC-CAP treatment': 'Available',
            'Non-TNBC-Control': 'NA',
            recommendedAnalysis: 'Metabolic Rewiring'
          },
          {
            key: '4',
            group: 'Lactylation',
            'TNBC-CAP treatment': 'Available',
            'TNBC-Control': 'Available',
            'Non-TNBC-CAP treatment': 'Available',
            'Non-TNBC-Control': 'NA',
            recommendedAnalysis: ''
          },
          {
            key: '5',
            group: 'Protome',
            'TNBC-CAP treatment': 'Available',
            'TNBC-Control': 'Available',
            'Non-TNBC-CAP treatment': 'NA',
            'Non-TNBC-Control': 'NA',
            recommendedAnalysis: 'Functional Activity'
          },
          {
            key: '6',
            group: 'Phosphorylome',
            'TNBC-CAP treatment': 'Available',
            'TNBC-Control': 'Available',
            'Non-TNBC-CAP treatment': 'NA',
            'Non-TNBC-Control': 'NA',
            recommendedAnalysis: ''
          },
        ],
      };
    },
    methods: {
      getClass(value, key) {
        const baseClass = value === 'Available' ? 'available-background' : 'na-background';
        return (this.selectedRowKey.includes(key) && value !== 'NA') ? `${baseClass} highlight-animation` : baseClass;
      },
      getLeftClass(key) {
        return this.selectedRowKey.includes(key) ? 'highlight-animation' : '';
      },
      highlightRow(rows) {
        console.log(rows)
        this.selectedRowKey = rows;
      },
      clearSelection() {
        this.selectedRowKey = [];
      },
    },
  }
  </script>
  
  <style scoped>
  table {
    width: 100%;
    border-collapse: collapse;
    table-layout: auto;
  }
  
  th, td {
    border: 1px solid #ccc;
    padding: 6px;
    text-align: center;
    font-size: 16px;
  }
  
  th {
    background-color: #FAFAFA;
  }
  
  .flexible-width {
    width: 15%;
  }
  
  .available-background {
      background-color: #b3e5fc;
  }
  
  .na-background {
    background-color: #f4d4d4;
  }
  
  .highlight-animation {
    animation: highlight 0.8s forwards;
  }
  
  @keyframes highlight {
    0% {
      background-color: #ffeb3b; /* 明亮的黄色 */
      font-weight: 600;
  }
   100% {
      background-color: #c8e6c9; /* 柔和的绿色 */
      font-weight: 600;
    }
  }
  </style>
  